import {
  Box,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Select,
} from "@chakra-ui/react";

import { BankInfo } from "../../../../types/requestCreditDataTypes";
import { useBranch } from "../../../../data/user";

interface BankStepProps {
  savedData: BankInfo;
  updateData: (data: BankInfo) => void;
}

const bank_account_types = ["Current", "Saving", "Other"];

const BankStep: React.FC<BankStepProps> = ({ savedData, updateData }) => {
  const { branch } = useBranch();
  return (
    <Box>
      <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={5}>
        <GridItem colSpan={1}>
          <FormControl isRequired>
            <FormLabel>Bank Name</FormLabel>
            <Input
              type="text"
              isInvalid={savedData?.bank_name === ""} // validation
              value={savedData?.bank_name}
              onChange={(e) => {
                updateData({
                  ...savedData,
                  bank_name: e.target.value,
                });
              }}
            />
          </FormControl>
        </GridItem>
        <GridItem colSpan={1}>
          <FormControl isRequired>
            <FormLabel>Bank Branch</FormLabel>
            <Input
              type="text"
              isInvalid={savedData?.bank_branch === ""} // validation
              value={savedData?.bank_branch}
              onChange={(e) => {
                updateData({
                  ...savedData,
                  bank_branch: e.target.value,
                });
              }}
            />
          </FormControl>
        </GridItem>
        <GridItem colSpan={1}>
          <FormControl isRequired>
            <FormLabel>Bank Account Number</FormLabel>
            <Input
              type="text"
              isInvalid={savedData?.bank_account_number === ""} // validation
              value={savedData?.bank_account_number}
              placeholder={
                branch === "UAE" ? "12345678901234567890" : "Enter bank account number"
              }
              onChange={(e) => {
                updateData({
                  ...savedData,
                  bank_account_number: e.target.value,
                });
              }}
            />
          </FormControl>
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormControl>
            <FormLabel>Bank IBAN</FormLabel>
            <Input
              type="text"
              isInvalid={savedData?.bank_iban === ""} // validation
              value={savedData?.bank_iban}
              placeholder={
                branch === "UAE" ? "AE12345678901234567890" : "Enter bank IBAN"
              }
              onChange={(e) => {
                updateData({
                  ...savedData,
                  bank_iban: e.target.value,
                });
              }}
            />
          </FormControl>
        </GridItem>
        <GridItem colSpan={1}>
          <FormControl isRequired>
            <FormLabel>Bank Swift</FormLabel>
            <Input
              type="text"
              isInvalid={savedData?.bank_swift === ""} // validation
              placeholder={
                branch === "UAE" ? "AEANB123456789" : "Enter bank SWIFT code"
              }
              value={savedData?.bank_swift}
              onChange={(e) => {
                updateData({
                  ...savedData,
                  bank_swift: e.target.value,
                });
              }}
            />
          </FormControl>
        </GridItem>

        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormControl isRequired>
            <FormLabel>Bank Account Type</FormLabel>

            <Select
              placeholder="Select Account Type"
              value={savedData?.bank_account_type}
              onChange={(e) => {
                updateData({
                  ...savedData,
                  bank_account_type: e.target.value,
                });
              }}
            >
              {bank_account_types.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </Select>
          </FormControl>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default BankStep;
